<template>
  <div>
    <PageAllow controller="Stocks" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet v-show="!currentItemMode" class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="stocksKeyword = $event"
                :label="$t('Stock.stocksKeyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>

              <v-spacer />
              <v-btn
                v-if="settings && settings.sync_hml_data == 1"
                small
                color="warning"
                @click.stop="syncHuaManLouStocks()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Stock.actions.SyncStocks") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('Stocks', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("Stock.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('DeliveryPoints', 'index') && settings && settings.delivery_point"
                small
                color="primary"
                class="ms-1"
                href="/#/stocks/delivery-point/"
              >
                {{ $t("Stock.actions.deliveryPoint") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('StockDistricts', 'tree')"
                small
                color="info"
                class="ms-1"
                href="/#/stocks/districts"
              >
                {{ $t("Stock.Fields.stock_district") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('StockTrucks', 'index')"
                small
                color="info"
                class="ms-1"
                href="/#/stocks/stock-trucks"
              >
                {{ $t("Stock.actions.stockTrucks") }}
              </v-btn>
              <v-menu
                v-if="
                  settings &&
                  settings.push_platform == 1018 &&
                  $permission.permissionAllow('StockIns', 'add') &&
                  $permission.permissionAllow('StockOuts', 'add')
                "
                v-model="syncKDBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="warning"
                    class="ms-1"
                  >
                    <v-icon x-small class="pe-1">fa-sync</v-icon>
                    {{ $t("Stock.actions.syncWithKingdee") }}
                    <v-icon x-small class="ps-1">
                      {{ syncKDBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click.stop="syncKingdeeStockOrders('sync_purchase_orders')"
                  >
                    <v-list-item-title>
                      {{ $t("Stock.actions.syncPurchaseOrdersWithKingdee") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="syncKingdeeStockOrders('sync_transfer_orders')"
                  >
                    <v-list-item-title>
                      {{ $t("Stock.actions.syncTransferOrdersWithKingdee") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockDistricts v-model="stockDistrictsSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Stock.status.ObjectName')"
                    :items="$consts.stock.status"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.types"
                    :label="$t('Stock.type.ObjectName')"
                    :items="$consts.stock.types"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stocks"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.type="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <v-chip v-if="item.type == 0" small label>
                {{ $t("Stock.type.real") }}
              </v-chip>
              <v-chip v-if="item.type == 1" small label>
                {{ $t("Stock.type.v_auto") }}
              </v-chip>
              <v-chip v-if="item.type == 2" small label>
                {{ $t("Stock.type.v_manual") }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status | stockStatusColor"
                :text-color="item.status | stockStatusTextColor"
              >
                {{ item.status | stockStatusText }}
              </v-chip>
            </template>
            <template v-slot:item.auto_requisition_from_stock="{ item }">
              {{ (item.auto_requisition_from_stock != 0 && item.auto_requisition_from) ? item.auto_requisition_from.name : '' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt</v-icon
                  >
                </template>
                <span>{{ $t("CRUD.viewInfo", [$t("Stock.ObjectName")]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Stocks', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.editInfo", [$t("Stock.ObjectName")]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Stocks', 'delete') && item.deletable"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.deleteInfo", [$t("Stock.ObjectName")]) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <StockDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getStocksFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Stock.ObjectName')"
      @confirm="
        deleteRole();
        deleteDialog = false;
      "
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Stocks from "@/api/stocks";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStockDistricts from "@/components/plugins/SearcherStockDistricts";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import StockDetail from "./plugins/Detail";
import KingdeeWorker from "@/api/kingdee_worker";
import snackbar from "@/plugins/snackbar";
import DialogDelete from "@/components/plugins/DialogDelete";

const defaultOptions = {
  stocksKeyword: "",
  district_id: "",
  district_ids: [],
  status: [0, 1, -1],
  types:[0, 1]
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherStockDistricts,
    SearcherStatus,
    StockDetail,
    DialogDelete,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: true,
        href: "/stocks",
      },
    ],

    headers() {
      let headers = [
        {
          text: i18n.t("Stock.Fields.stock_code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: i18n.t("Stock.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("Stock.Fields.stock_district"),
          align: "start",
          sortable: false,
          value: "stock_district.name",
        },
        {
          text: i18n.t("Stock.Fields.stock_manager"),
          align: "start",
          sortable: false,
          value: "manager",
        },
        {
          text: i18n.t("Stock.Fields.tel"),
          align: "start",
          sortable: false,
          value: "tel",
        },
        {
          text: i18n.t("Stock.Fields.type"),
          align: "center",
          sortable: false,
          value: "type",
        },
      ]

      if (this.$permission.permissionAllow('Requisitions', 'addViews')) {
        headers.push(
          {
            text: i18n.t("Stock.Fields.auto_requisition_from_stock"),
            align: "start",
            sortable: false,
            value: "auto_requisition_from_stock"
          },
        )
      }
      headers.push(
        {
          text: i18n.t("Stock.Fields.memo"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "memo",
        },
        {
          text: i18n.t("Stock.Fields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      )
      return headers
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("stocks", ["stockDistrictsSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stockDistrictsSelected":
              this.stockDistrictsSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  data: () => ({
    stocks: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stocks-options")
        ? sessionStorage.getItem("stocks-options")
        : JSON.stringify(defaultOptions)
    ),
    stocksKeyword: "",
    currentItemMode: null,
    currentItem: null,
    stockDistrictsSelected: [],
    initialize: 0,
    syncKDBtnMenu: false,
    deleteDialog: false,
  }),

  methods: {
    resetSearch() {
      this.stockDistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.stocksKeyword,
      });
    },
    getStocksFromAPI() {
      Stocks.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    syncKingdeeStockOrders(event) {
      this.$store.dispatch("fullscreenLoading");
      KingdeeWorker.addJob({
        event: event,
        param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
      }).then(
        function (response) {
          if (response) {
            if (response.data.status.isOK()) {
              snackbar.success(i18n.t("Stock.syncWithKingdee"));
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    deleteRole() {
      if (this.currentItem)
        Stocks.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getStocksFromAPI(); // 删除成功的话刷新数据
            }
          }.bind(this)
        );
    },
    syncHuaManLouStocks() {
      this.$store.dispatch("fullscreenLoading");
      Stocks.syncHuaManLouStocks().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getStocksFromAPI(); // 同步成功的话刷新数据
            snackbar.success(i18n.t("Stock.SyncStocks"));
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem)
          this.$router.replace("/stocks?id=" + this.currentItem.id);
        else this.$router.replace("/stocks");
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getStocksFromAPI();
        sessionStorage.setItem("stocks-options", JSON.stringify(this.options));
      },
    },
    stockDistrictsSelected: {
      handler() {
        this.options.district_ids = this.stockDistrictsSelected
          ? this.stockDistrictsSelected.map((stockDistrict) => {
              return stockDistrict.id;
            })
          : "";
        sessionStorage.setItem(
          "stocks-stockDistrictsSelected",
          JSON.stringify(this.stockDistrictsSelected)
        );
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>